import React from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import InfoView from 'components/InfoView';
import { userSignIn } from 'actions/Auth';
import jwtDecode from "jwt-decode";

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      email: '',
      password: ''
    }
  }

  componentDidUpdate() {
    if (this.props.userType >= 0) {
      let payload = jwtDecode(localStorage.getItem("mhc"))
      if(payload.role_id === 3){
        this.props.history.push('/patient/corporate');
        return ;
      }
      if(payload.role_id === 5){
        this.props.history.push('/createappointment');
        return ;
      }
      if(payload.role_id === 17){
        this.props.history.push('/waitingRoomManagement');
        return ;
      }
      if(payload.role_id === 4){
        this.props.history.push('/logout');
        return ;
      }
      if(payload.role_id === 18){ //Starmed Teleconsult Report
        this.props.history.push('/report/teleconsult');
        return ;
      }
      switch (this.props.userType) {
        case 0:
          this.props.history.push('/dashboard');
          break ;
        case 1:
          this.props.history.push('/dashboard');
          break ;
        case 3:
          this.props.history.push('/dashboard');
          break ;
        default:
          return null
      }
    }
  }

  render() {
    const {
      email,
      password
    } = this.state;
    return (
      <div
        className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">

          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="/" title="Jambo">
              <img src={require("assets/images/logo_new.png")} alt="BetterHealth" title="BetterHealth" style={{maxWidth: 100}} />
            </Link>
          </div>

          <div className="app-login-content">
            {/* <div className="app-login-header mb-4">
              <h1><IntlMessages id="appModule.email" /></h1>
            </div> */}

            <div className="app-login-form">
              <form>
                <fieldset>
                  <TextField
                    label={<IntlMessages id="appModule.email" />}
                    fullWidth
                    onChange={(event) => this.setState({ email: event.target.value })}
                    defaultValue={email}
                    margin="normal"
                    className="mt-1 my-sm-3"
                  />
                  <TextField
                    type="password"
                    label={<IntlMessages id="appModule.password" />}
                    fullWidth
                    onChange={(event) => this.setState({ password: event.target.value })}
                    defaultValue={password}
                    margin="normal"
                    className="mt-1 my-sm-3"
                  />

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <Button onClick={() => {
                      this.props.userSignIn({ email, password });
                    }} variant="contained" color="primary">
                      <IntlMessages id="appModule.signIn" />
                    </Button>

                    <Link to="/signup">
                      <IntlMessages id="signIn.signUp" />
                    </Link>
                    
                  </div>
                </fieldset>
              </form>
            </div>
          </div>

        </div>
        <InfoView />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { userType } = auth;
  return { userType }
};

export default connect(mapStateToProps, { userSignIn })(SignIn);
